import { styled } from '@mui/material';

export const Line = styled('hr')(() => ({
  borderBottom: '1px solid var(--color-medium-light-grey)',
  borderTop: 'none',
}));
